import styled from 'styled-components';
const maxHeight = 650;
const width = 450;
const topRight = `
 top: 16px !important;
 right: 16px !important;
`;
const topLeft = `
 top: 16px !important;
 left: 16px !important;
`;
const bottomRight = `
 bottom: 16px !important;
 right: 16px !important;
`;
const bottomLeft = `
 bottom: 16px !important;
 left: 16px !important;
`;
const getChatPlacementStyles = (position) => {
    switch (position) {
        case "BottomLeft":
            return bottomLeft;
        case "BottomRight":
            return bottomRight;
        case "TopLeft":
            return topLeft;
        case "TopRight":
            return topRight;
    }
};
const AppContainer = styled.div `
    background-color: white;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.08), 0 2px 4px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 5px;
    padding: 0;
    font-family: ${(props) => props.theme.fontFamily} !important;
    border-radius: 10px;
    overflow: hidden; 
    @media screen and (min-height: 0) and (max-height: 675px) {
        height: calc(var(--vh) - 20px);
    }

    @media screen and (min-height: 676px) {
        height: ${maxHeight}px;
    }

    @media screen and (min-width: 0) and (max-width: ${props => props.mobileBreakpoint}px) {
        width: 100%;
        bottom: 0;
        right: 0;
        height: calc(var(--vh) - 1px);
        border-radius: 0;
    }

    @media screen and (min-width: ${props => props.mobileBreakpoint + 1}px) {
        width: ${width}px;
      ${(props) => getChatPlacementStyles(props.position)}
    }        

    z-index: ${props => props.zIndex};
    margin: 0;
    position: fixed;
    line-height: 1.15;
    top: auto;
    left: auto;        
`;
const ContentContainer = styled.div `
    position: relative;
    width: 100%;
    height :100%;
    display: flex;
    flex-direction:column;
    overflow: hidden;    
    border-radius: 10px;
    @media screen and (min-width: 0) and (max-width: 600px) {
        border-radius: 0;
    }
`;
export { AppContainer, ContentContainer };
